import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function ShellBack() {
	return (
		<g>
			<path className="fill fill--light" d="M371.3501587,308.4816589c0,13.9603271-39.2392578,41.219696-115.9666901,41.219696
				s-115.9873657-27.2593689-115.9873657-41.219696v-0.0930786c0-69.8253937,51.9200592-115.9381866,115.9666901-115.9381866
				s115.9666748,46.112793,115.9666748,115.9381866L371.3501587,308.4816589z" />
			<path className="fill" d="M255.3505249,323.1589355
				c-46.9255219,0-48.3117218-42.3075562-87.5112-42.3075562c-17.7304077,0-32.4064789,28.4089966-34.0817871,27.1079102
				c-3.4686584-2.6938782-5.2108002-5.7794189-5.2107697-9.2827759
				c-0.0001678-68.089447,56.7945862-120.3929138,126.8263702-120.3929138s126.8265076,52.3034668,126.826355,120.3929138
				c0.0001526,17.3858948-42.9061584,24.4824219-126.8037567,24.4824219H255.3505249z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/ShellBack.js